import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SubWorkflowTrigger from './SubWorkflowTrigger';
import ContextualTextColor from './ContextualTextColor';
import { analyseEvaluatedText } from '../../commons/evaluatedTextVerfier';
import DisplayFile from './DisplayFile';

class TextStyleResolver extends Component {
    render() {
        const { config, text, cellStyle, customIcons, isCardTitle, keyValue, toggleImageModal, showAsBadge, showInModal, companyDetails, whiteSpace,title, cardExternalpath, ...rest } = this.props;
        if (!config && !text) return null;
        if (!config) return text;
        const { isTextualActionTriggerEnabled, contextual_text_color, rules } = config;
        let updatedCellStyle = cellStyle ? cellStyle : {};
        if (whiteSpace == 'nowrap') {
            updatedCellStyle['whiteSpace'] = "nowrap";
        }
        if (config.fileType && config.fileType.value) {
            return <DisplayFile config={config} text={text} toggleImageModal={toggleImageModal} companyDetails={companyDetails} />
        }
        if (contextual_text_color) {
            return <ContextualTextColor customIcons={customIcons} text={text} config={config} showAsBadge={showAsBadge}  {...rest} />
        }
        if (isTextualActionTriggerEnabled) {
            return <SubWorkflowTrigger text={text} config={config} keyValue={keyValue} {...rest} />
        }
        if (rules) {
            rules.forEach((x, i) => {
                const r = this.props.checkRule(x, this.props.rows.getObjectAt(this.props.rowIndex))
                if (r) {
                    updatedCellStyle['color'] = x.color
                }
            })
        }
        const analysedText = analyseEvaluatedText(text);
        let showAsLink = false;
        try {
            showAsLink = analysedText && (analysedText.indexOf('http:') != -1 || analysedText.indexOf('https:') != -1
                || analysedText.indexOf('www.') != -1);
        } catch (error) { }


                let imgUrl = "";
                if (typeof analysedText === "string") {
                imgUrl = analysedText &&  (analysedText.indexOf('http:') == -1 && analysedText.indexOf('https') == -1 ? "//" : "") + analysedText
                }
                let cleanedUrl = imgUrl.replace(/(?<!:)\/+/g, "/");
                    imgUrl = cleanedUrl
                                
                                        
        return (// DEFAULT PRINT
           showAsLink ? showInModal ? <a href="#" onClick={this.props.toggleModal}>
                            {analysedText}
                        </a> : <a href={imgUrl} target="_blank">{imgUrl}</a> :
                            <span title={analysedText} style={updatedCellStyle}>{analysedText}</span>
          
        )
    }
}

TextStyleResolver.defaultProps = {
    config: null,
    text: null
}

TextStyleResolver.propTypes = {
    config: PropTypes.object
};

export default TextStyleResolver;